// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingsMock_wrapper__+80KZ","title":"SettingsMock_title__sujhc","contimg":"SettingsMock_contimg__byLav","img":"SettingsMock_img__NlGmV","info":"SettingsMock_info__E9-mg"};